export const debounce = (callback: (...args: any[]) => void, wait: number) => {
  let timeoutId: number | null = null;

  return (...args: any[]) => {
    if (timeoutId) window.clearTimeout(timeoutId);

    timeoutId = window.setTimeout(() => {
      callback(...args);
    }, wait);
  };
};

// Throttle.
export const throttle = (callback: (...args: any[]) => void, wait: number) => {
  let inThrottle: boolean;

  return (...args: any[]) => {
    if (!inThrottle) {
      callback(...args);
      inThrottle = true;
      setTimeout(() => (inThrottle = false), wait);
    }
  };
};
